(function () {
  'use strict';

  // The index and URLs use gross base-currency prices. Only this filter's
  // controls convert them; Shopify.currency.rate must remain a currency rate.
  const round = (value) => Math.round((value + Number.EPSILON) * 100) / 100;
  const parse = (value) => {
    const text = String(value).trim().replace(',', '.');
    return /^\d+(?:\.\d*)?$/.test(text) ? Number(text) : null;
  };
  const parseRange = (value) => {
    const match = /^\[([\d.]+),\s*([\d.]+)\]$/.exec(value || '');
    return match ? match.slice(1).map(Number) : null;
  };
  const scale = () => {
    const currencyRate = Number(window.Shopify?.currency?.rate) || 1;
    const net = window.mdPrice?.enabled !== false && window.mdPrice?.mode === 'net';
    return currencyRate / (net ? 1 + (Number(window.MundizioCards?.taxRate) || 19) / 100 : 1);
  };
  const bounds = (facet, selected, factor) => {
    const raw = [Number(facet.minValue), Number(facet.maxValue)];
    const limits = raw.map((value) => round(value * factor));
    return { raw, limits, values: (selected || raw).map((value) => round(value * factor)) };
  };
  const toRaw = (value, index, state, factor) => value === state.limits[index]
    ? state.raw[index] : Number((value / factor).toFixed(6));
  const controllers = new Map();

  function attach(key) {
    if (controllers.has(key)) return;
    const store = window.RCCSearchStores?.[key];
    const root = Array.from(document.querySelectorAll('[data-search-store]'))
      .find((node) => node.dataset.searchStore === key);
    if (!store?.setFilters || !root) return;
    let frame;
    const locale = window.MundizioCards?.locale || 'de-DE';
    const number = new Intl.NumberFormat(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const money = new Intl.NumberFormat(locale, { style: 'currency', currency: window.MundizioCards?.currency || 'EUR' });
    const schedule = () => { if (!frame) frame = requestAnimationFrame(sync); };
    const observer = new MutationObserver(schedule);
    const observe = () => observer.observe(root, { childList: true, subtree: true, characterData: true });

    function sync() {
      frame = null;
      observer.disconnect();
      const facet = store.signals.facets.value.find((item) => item.key === 'price')?.values?.[0];
      const filters = store.signals.userFilters.value;
      const price = filters.find((item) => item.field === 'price');
      const selected = parseRange(price?.value?.[0]);
      const factor = scale();
      if (facet && Number.isFinite(Number(facet.minValue)) && Number.isFinite(Number(facet.maxValue))) {
        const state = bounds(facet, selected, factor);
        root.querySelectorAll('.rcc-search__facet--price .rcc-search__range:not([data-md-price-range])').forEach((native) => {
          let control = native.nextElementSibling;
          if (!control?.hasAttribute('data-md-price-range')) {
            control = native.cloneNode(true);
            control.setAttribute('data-md-price-range', '');
            control.hidden = false;
            control.removeAttribute('aria-hidden');
            control.style.removeProperty('display');
            native.after(control);
            const note = document.createElement('div');
            note.className = 'rcc-price-filter__vat';
            control.append(note);
            control.addEventListener('input', (event) => {
              if (event.target.type === 'range') update(control, event.target);
            });
            control.addEventListener('change', (event) => commit(control, event.target));
            control.addEventListener('keydown', (event) => {
              if (event.key === 'Enter') { event.preventDefault(); commit(control, event.target); }
            });
          }
          native.style.display = 'none';
          native.setAttribute('aria-hidden', 'true');
          control._priceState = { ...state, factor, selected };
          // Do not replace a partially typed value on unrelated app renders.
          if (!control.contains(document.activeElement) || control.dataset.factor !== String(factor)) {
            paint(control, state.values);
          }
          control.dataset.factor = factor;
          control.querySelector('.rcc-price-filter__vat').textContent =
            window.mdPrice?.mode === 'net' ? 'zzgl. MwSt.' : 'inkl. MwSt.';
        });
      }
      if (selected) {
        const summary = selected.map((value) => money.format(value * factor)).join(' – ');
        root.querySelectorAll('.rcc-search__facet--price .rcc-search__facet__summary').forEach((node) => {
          if (node.textContent !== summary) node.textContent = summary;
        });
        const title = root.querySelector('.rcc-search__facet--price .rcc-search__facet__title span')?.textContent || 'Preis';
        root.querySelectorAll('.rcc-search__summary__button').forEach((button) => {
          const label = button.querySelector('.rcc-search__summary__option')?.textContent.replace(/:$/, '').trim();
          if (label !== title) return;
          const value = button.querySelector('.rcc-search__summary__value');
          if (value && value.textContent !== summary) value.textContent = summary;
          button.setAttribute('aria-label', `${title}: ${summary} entfernen`);
        });
      }
      observe();
    }

    function paint(control, values) {
      const { limits } = control._priceState;
      control.querySelectorAll('.rcc-search__range__input').forEach((input, index) => {
        input.value = number.format(values[index]);
        input.setAttribute('aria-label', index ? 'Preis bis' : 'Preis von');
      });
      control.querySelectorAll('input[type="range"]').forEach((input, index) => {
        input.min = Math.min(limits[0], values[0]);
        input.max = Math.max(limits[1], values[1]);
        input.step = '0.01';
        input.value = values[index];
        input.setAttribute('aria-label', index ? 'Höchstpreis' : 'Mindestpreis');
        input.setAttribute('aria-valuetext', money.format(values[index]));
      });
      const width = limits[1] - limits[0] || 1;
      const bar = control.querySelector('.rcc-search__range__bar');
      bar.style.setProperty('--rcc-range-start', `${Math.max(0, (values[0] - limits[0]) / width * 100)}%`);
      bar.style.setProperty('--rcc-range-end', `${Math.min(100, (values[1] - limits[0]) / width * 100)}%`);
    }

    function update(control, input) {
      const sliders = Array.from(control.querySelectorAll('input[type="range"]'));
      const values = sliders.map((node) => Number(node.value));
      if (values[0] > values[1]) values[sliders.indexOf(input) === 0 ? 1 : 0] = Number(input.value);
      paint(control, values);
    }

    function commit(control, input) {
      const fields = Array.from(control.querySelectorAll('.rcc-search__range__input'));
      if (!fields.includes(input) && input.type !== 'range') return;
      const state = control._priceState;
      const values = fields.map((node) => parse(node.value.replace(/\.(?=\d{3}(?:\D|$))/g, '')));
      if (values.some((value) => value === null || !Number.isFinite(value)) || values[0] > values[1]) {
        paint(control, state.values);
        return;
      }
      const raw = values.map((value, index) => value === state.values[index]
        ? (state.selected || state.raw)[index] : toRaw(value, index, state, state.factor));
      const filters = store.signals.userFilters.value.filter((item) => item.field !== 'price');
      const complete = raw[0] <= state.raw[0] && raw[1] >= state.raw[1];
      if (!complete) filters.push({ field: 'price', value: [`[${raw[0]},${raw[1]}]`] });
      if (JSON.stringify(filters) !== JSON.stringify(store.signals.userFilters.value)) store.setFilters(filters);
      control._priceState = { ...state, values, selected: complete ? null : raw };
      paint(control, values);
    }

    const unsubscribers = ['facets', 'userFilters'].map((name) => store.signals[name].subscribe(schedule));
    document.addEventListener('md:pricemode', schedule);
    controllers.set(key, () => {
      observer.disconnect();
      cancelAnimationFrame(frame);
      unsubscribers.forEach((unsubscribe) => unsubscribe());
      document.removeEventListener('md:pricemode', schedule);
    });
    sync();
  }

  window.addEventListener('rcc-search-store:registered', (event) => requestAnimationFrame(() => attach(event.detail.storeKey)));
  window.addEventListener('rcc-search-store:removed', (event) => {
    controllers.get(event.detail.storeKey)?.();
    controllers.delete(event.detail.storeKey);
  });
  Object.keys(window.RCCSearchStores || {}).forEach(attach);
})();
